export default function CategoryHero({ eyebrow, title, description }) {
  return (
    <section className="marketplace-category-hero">
      <div className="container">
        <span className="marketplace-eyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
    </section>
  )
}
